import {
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Box, Button } from '@superdispatch/ui-lab';
import { UserDTO } from '../../users/data/UsersDTO';
import { DriverDTO } from 'shared/modules/driver/DriverDTO';
import styled from 'styled-components';

const DialogActions = styled(MuiDialogActions)`
  padding-bottom: 16px;
`;

interface PendingActivationDriverDialogProps {
  driver: DriverDTO | UserDTO | null | undefined;
  onClose: () => void;
}

export function PendingActivationDriverDialog({
  driver,
  onClose,
}: PendingActivationDriverDialogProps) {
  const phoneNumber = getPhoneNumber(driver);

  return (
    <Dialog open={!!driver}>
      <DialogTitle>
        {driver?.name || driver?.email} is Pending Activation
      </DialogTitle>
      <DialogContent>
        <Typography>
          The load has been assigned but the driver is pending activation. The
          driver was sent a text message to <b>{phoneNumber}</b> and email to{' '}
          <b>{driver?.email}</b> with instructions on how to download the Super
          Dispatch driver app and activate their account.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box paddingTop="xsmall">
          <Button variant="primary" onClick={onClose}>
            Got it
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

function getPhoneNumber(
  driver: UserDTO | DriverDTO | null | undefined,
): string {
  return driver && 'phone' in driver
    ? driver.phone
    : driver?.phone_number || '';
}
